import { Component, OnInit } from '@angular/core';
import { fadeAnimation } from './animations/fade.animation';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';
import { SpeedometerLoaderComponent } from './shared/speedometer-loader/speedometer-loader.component';
import { LanguageService } from './services/language.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  animations: [fadeAnimation]
})
export class AppComponent implements OnInit {

  public speedometerLoaderComponent = SpeedometerLoaderComponent;
  isLoggedIn: boolean;

  constructor(private authService: AuthService,
              private translate: TranslateService,
              private languageService: LanguageService,
              private titleService: Title) {
    this.initTranslate();
  }

  ngOnInit() {
    this.authService.currentUser.subscribe(currentUser => this.isLoggedIn = !!(currentUser));
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  initTranslate() {
    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang('de');
    this.languageService.changeLanguage().subscribe();
    this.translate.get('BASE_TITLE').subscribe(
      (translation) => {
        this.titleService.setTitle(translation);
      }
    );

  }

}
